import React from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FaThumbsUp, FaRegCommentDots, FaPlayCircle, FaHeart, FaStar } from 'react-icons/fa';
import logo from '../img/n89.png';
import '../styles/compsStyles/authPrompt.css';

export const useAuthGate = () => {
  const userid = useSelector(state => state.authReduse.id);
  const [open, setOpen] = React.useState(false);

  const requireAuth = () => {
    if (userid) return true;
    setOpen(true);
    return false;
  };

  const promptEl = (
    <AuthPrompt open={open} onClose={() => setOpen(false)} />
  );

  return { userid, requireAuth, promptEl };
};

const AuthPrompt = ({ open, onClose }) => {
  const navigate = useNavigate();
  if (!open) return null;

  return createPortal(
    <div className="authPromptBackdrop" onClick={onClose} role="presentation">
      <div
        className="authPrompt"
        role="dialog"
        aria-modal="true"
        aria-labelledby="authPromptTitle"
        onClick={event => event.stopPropagation()}
      >
        <div className="authPromptGlow authPromptGlow--one" />
        <div className="authPromptGlow authPromptGlow--two" />
        <div className="authPromptGlow authPromptGlow--three" />

        <span className="authPromptFloat authPromptFloat--heart"><FaHeart /></span>
        <span className="authPromptFloat authPromptFloat--star"><FaStar /></span>
        <span className="authPromptFloat authPromptFloat--play"><FaPlayCircle /></span>
        <span className="authPromptFloat authPromptFloat--comment"><FaRegCommentDots /></span>
        <span className="authPromptFloat authPromptFloat--like"><FaThumbsUp /></span>

        <button type="button" className="authPromptClose" onClick={onClose} aria-label="Close">×</button>

        <div className="authPromptBrand">
          <img className="authPromptLogo" src={logo} alt="Pinweelo" />
          <p className="authPromptWordmark">Pinweelo</p>
          <span className="authPromptTag">Watch. React. Belong.</span>
        </div>

        <h1 id="authPromptTitle">Join the moment</h1>
        <p className="authPromptLead">
          Log in to like videos, comment, and follow creators.
        </p>

        <ul className="authPromptPerks">
          <li>
            <FaThumbsUp />
            <div>
              <strong>Like what hits</strong>
              <span>Save clips you love.</span>
            </div>
          </li>
          <li>
            <FaRegCommentDots />
            <div>
              <strong>Talk in the comments</strong>
              <span>Reply and start the conversation.</span>
            </div>
          </li>
          <li>
            <FaPlayCircle />
            <div>
              <strong>Stay in the stream</strong>
              <span>Follow creators so the next video finds you.</span>
            </div>
          </li>
        </ul>

        <div className="authPromptActions">
          <button type="button" className="authPromptLogin" onClick={() => navigate('/auth')}>
            Log in to Pinweelo
          </button>
          <button type="button" className="authPromptLater" onClick={onClose}>
            Keep watching
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AuthPrompt;
